import React, { Fragment } from 'react';
import { Reorder } from 'framer-motion';

import AccordionItem from '../custom-visual-inspection/accordion-item';
import CustomNewItem from '../custom-general/custom-new-item';
import TOFDScanDataForm from '../../forms/custom-tofd/tofdScanData';
import ReorderItem from '../../common/reorderItem';

import { PDFImageProps } from '../../../utils/models';

export interface TOFDScanDataItem {
    id: number;
    weldNumber: string;
    scanNumber: string;
    scanAngle: number;
    aScan: PDFImageProps[],
    sScan: PDFImageProps[],
    thickness: number;
    pipeDia: number;
    defectType: string;
    defectDepth: number;
    defectLength: number;
    defectHeight: number;
    scanStart: number;
    scanEnd: number;
    minimumMeasuredThickness: number;
    result: string;
    limitation: string;
    remark: string;
}

interface Props {
    tofdScanDataItems: TOFDScanDataItem[];
	onDataChange: (items: TOFDScanDataItem[]) => void;
}

const TOFDScanDataItems: React.FC<Props> = (props) => {
	const handleAddItem = (item: TOFDScanDataItem) => {
		props.onDataChange([...props.tofdScanDataItems, { ...item, id: props.tofdScanDataItems.length + 1 }]);
	};

	const handleDeleteItem = (item: TOFDScanDataItem): void => {
		const newAnomalyItems = props.tofdScanDataItems.filter((tofdItem) => tofdItem.id !== item.id);
		props.onDataChange(newAnomalyItems);
	};

	const handleEditItem = (originalItem: TOFDScanDataItem, updatedItem: TOFDScanDataItem): void => {
        const updatedItems = props.tofdScanDataItems.map((tofdItem) => tofdItem.id === originalItem.id ? updatedItem : tofdItem);
		props.onDataChange(updatedItems);
	};

	return (
		<Fragment>
            <CustomNewItem label='Add New TOFD Scan Data'>
                <TOFDScanDataForm onSave={handleAddItem} />
            </CustomNewItem>

			<div className="divider my-4"></div>

            <Reorder.Group className='list-unstyled' values={props.tofdScanDataItems} onReorder={props.onDataChange}>
                {props.tofdScanDataItems.map((item) => (
                    <ReorderItem key={item.id} value={item}>
                        <AccordionItem key={item.id} title={item.weldNumber + ' ' + item.scanNumber} isActive isOpenOnDefault={false}>
                            <TOFDScanDataForm
                                initialTOFDItem={item}
                                onDeleteItem={() => handleDeleteItem(item)}
                                onSave={(updatedItem: TOFDScanDataItem) => handleEditItem(item, updatedItem)} 
                            />
                        </AccordionItem>
                    </ReorderItem>
                ))}
            </Reorder.Group>
		</Fragment>
	);
};

export default TOFDScanDataItems;